import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  loading = false;
  errorMessage = '';
  private fb: FormBuilder = new FormBuilder();
  hideConfirmPassword = true;
  hideNewPassword = true;

  form = this.fb.group(
    {
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
          Validators.pattern(/^[A-Za-z0-9@$!%*?&#_\-]+$/)
        ]
      ],
      confirmPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16),
          Validators.pattern(/^[A-Za-z0-9@$!%*?&#_\-]+$/)
        ]
      ]
    },
    {
      validators: this.passwordMatchValidator
    }
  );


  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  passwordMatchValidator(group: AbstractControl) {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;

    return newPassword === confirmPassword
      ? null
      : { passwordMismatch: true };
  }

  get passwordControl() {
    return this.form.get('newPassword');
  }

  get passwordRules() {
    const value = this.passwordControl?.value || '';

    return {
      length: value.length >= 8 && value.length <= 16,
      alphanumericOrSpecial: /^(?=.*[A-Za-z])(?=.*([0-9]|[@$!%*?&#_\-]))[A-Za-z0-9@$!%*?&#_\-]+$/.test(value),
    };

  }



  submit() {
    if (this.form.invalid) return;

    const { newPassword, confirmPassword } = this.form.value;

    if (newPassword !== confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    this.authService.resetPassword({ password: newPassword }).subscribe({
      next: () => {
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }
}
